import Nullstack from 'nullstack';
export default function IconTopologyFullHierarchy({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-topology-full-hierarchy",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M18 16v-8"
  }), "   ", Nullstack.element("path", {
    d: "M8 6h8"
  }), "   ", Nullstack.element("path", {
    d: "M16 18h-8"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 7.5l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 13.5l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M16.5 7.5l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 13.5l-3 3"
  }), " ");
}